<template>
  <div
    class="min-height dashboard-screen-container inputcontainer theme--light"
  >
    <loader v-if="showLoader"></loader>
    <CRow>
      <CCol sm="6" class="d-align">
        <h3 class="m-0">DocSmart Dashboard</h3>
      </CCol>
      <CCol sm="6">
        <CRow>
          <CCol sm="6" class="datepicker pos-r">
            <label for>Date Range</label>
            <datepicker
              v-model="dateRange"
              @input="dateChange()"
              ref="datepicker"
              :model-config="datePickerConfig"
              :max-date="new Date()"
              is-range
              :masks="{ input: 'DD-MM-YYYY' }"
            >
              <template v-slot="{ inputValue, inputEvents }">
                <input
                  :value="
                    !!inputValue.start && !!inputValue.end
                      ? inputValue.start + ' - ' + inputValue.end
                      : 'DD/MM/YYYY'
                  "
                  v-on="inputEvents.start"
                  class="form-control position-relative"
                  placeholder="DD/MM/YYYY"
                />
                <div
                  v-if="!!inputValue.start && !!inputValue.end"
                  class="cross-svg"
                  @click="resetActiveDate"
                >
                  <crossSVG />
                </div>
              </template>
            </datepicker>
            <div class="calendarsvg pos-svg pos-a">
              <calendarSVG />
            </div>
          </CCol>
        </CRow>
      </CCol>
    </CRow>
    <!-- ........................................................... -->
    <CRow>
      <CCol sm="6" class="lg-card">
        <div class="value-card d-align">
          <div class="icon-div">
            <image-view
              :src="'/img/avatars/transfer.png'"
              class="mr-1"
            ></image-view>
          </div>
          <div class="ml-4">
            <h5>CC Avenue fees</h5>
            <h5 class="text-success mb-0">
              {{ dashboardData.razor_pay_fee | currency }}
            </h5>
          </div>
        </div>
      </CCol>
      <CCol sm="6" class="lg-card">
        <div class="value-card d-align">
          <div class="icon-div">
            <image-view
              :src="'/img/avatars/transfer.png'"
              class="mr-1"
            ></image-view>
          </div>
          <div class="ml-4">
            <h5>Video Consultation Vendor Fees</h5>
            <h5 class="text-success mb-0">
              {{ dashboardData.video_consultation_fee | currency }}
            </h5>
          </div>
        </div>
      </CCol>
    </CRow>
    <!-- ........................................................... -->
    <CRow>
      <CCol sm="4">
        <div class="value-card">
          <div class="d-flex mb-2">
            <div class="icon-div">
              <image-view
                :src="'/img/avatars/transfer.png'"
                class="mr-1"
              ></image-view>
            </div>
            <div class="ml-4">
              <h5>Total Transactions</h5>
              <h5 class="text-success mb-0">
                {{ dashboardData.total_transaction | currency }}
              </h5>
            </div>
          </div>
          <hr class="hr-line" />
          <div class="d-just-space mb-3">
            <div>
              <h6 class="mb-0">Total Online Transactions</h6>
              <small>(via Payment Gateway)</small>
            </div>
            <div>
              <h6>{{ dashboardData.total_online_payment | currency }}</h6>
            </div>
          </div>
          <div class="d-just-space mb-3">
            <div>
              <h6 class="mb-0">Total Offline Transactions</h6>
              <small>(via cash, cheque etc)</small>
            </div>
            <div>
              <h6>{{ dashboardData.total_offline_transaction | currency }}</h6>
            </div>
          </div>
          <div class="d-just-space">
            <div>
              <h6 class="mb-0">DocSmart Income</h6>
            </div>
            <div>
              <h6>{{ dashboardData.total_income | currency }}</h6>
            </div>
          </div>
        </div>
      </CCol>
      <CCol sm="4">
        <div class="value-card">
          <div class="d-flex mb-2">
            <div class="icon-div">
              <image-view
                :src="'/img/avatars/transfer.png'"
                class="mr-1"
              ></image-view>
            </div>
            <div class="ml-4">
              <h5>Total Utility fees</h5>
              <h5 class="text-success mb-0">
                {{ dashboardData.total_utility_fees | currency }}
              </h5>
            </div>
          </div>
          <hr class="hr-line" />
          <div class="d-just-space mb-3">
            <div>
              <h6 class="mb-0">DocSmart Utility Income</h6>
            </div>
            <div>
              <h6>
                {{ getDocSmartUtilityIncome(dashboardData) }}
              </h6>
            </div>
          </div>
        </div>
      </CCol>
      <CCol sm="4">
        <div class="value-card">
          <div class="d-flex mb-2">
            <div class="icon-div">
              <image-view
                :src="'/img/avatars/transfer.png'"
                class="mr-1"
              ></image-view>
            </div>
            <div class="ml-4">
              <h5>GST Total</h5>
              <h5 class="text-success mb-0">
                {{ dashboardData.total_payable_gst | currency }}
              </h5>
            </div>
          </div>
          <hr class="hr-line" />
          <div class="d-just-space mb-3">
            <div>
              <h6 class="mb-0">Payment Gateway</h6>
            </div>
            <div>
              <h6>{{ getPaymentGateway(dashboardData) }}</h6>
            </div>
          </div>
          <div class="d-just-space mb-3">
            <div>
              <h6 class="mb-0">Video Consultation Vendor</h6>
            </div>
            <div>
              <h6>{{ dashboardData.gst_on_video_charge | currency }}</h6>
            </div>
          </div>
        </div>
      </CCol>
    </CRow>
    <!-- ........................................................... -->

    <!-- ........................................................... -->
  </div>
</template>
<script>
const loader = () => import("@/components/loader.vue");
const Datepicker = () => import("v-calendar/lib/components/date-picker.umd");
import { pickSvg } from "@/views/SVG";
const Image = () => import("@/components/image.vue");
import Config from "@/config.js";
const API_URL = `${Config.ACCOUNTS_URL}ds-accounts-be`;
const dayJS = require("@/methods/dayjs")
  .advancedFormat()
  .customParseFormat()
  .isBetween()
  .build();

export default {
  components: {
    loader,
    Datepicker,
    ...pickSvg("crossSVG", "calendarSVG", "searchSVG"),
    "image-view": Image,
  },
  data() {
    return {
      dashboardData: {
        razor_pay_fee: 0,
        video_consultation_fee: 0,
        total_transaction: 0,
        total_online_payment: 0,
        total_offline_transaction: 0,
        total_income: 0,
        total_utility_fees: 0,
        total_payable_gst: 0,
        gst_on_video_charge: 0,
      },
      showLoader: false,
      search: "",
      datePickerConfig: {
        start: {
          timeAdjust: "00:00:00",
        },
        end: {
          timeAdjust: "23:59:59",
        },
      },
      dateRange: {
        start: new Date(),
        end: new Date(),
      },
    };
  },
  created() {
    this.dateRange.start = new Date();
    this.dateRange.start.setDate(this.dateRange.start.getDate() - 90);
    this.getDashboard();
  },
  filters: {
    currency(val) {
      return new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
      }).format(val);
    },
  },
  methods: {
    clearSearch() {
      this.search = "";
    },
    dateChange() {
      this.getDashboard();
      // this.getBlogList();
    },
    resetActiveDate() {
      this.dateRange = { start: "", end: "" };
      this.dashboardData = {};
      this.getDashboard();
    },
    getDashboard() {
      this.showLoader = true;
      let body = {
        start_date: this.dateRange.start
          ? this.dateRange.start.toISOString()
          : "",
        end_date: this.dateRange.end ? this.dateRange.end.toISOString() : "",
      };
      let url = `${API_URL}/v2/transaction/accounts-master-count`;
      this.$http.post(url, body).then(
        (response) => {
          const { status, data } = response.data;
          if (status) {
            this.dashboardData = data;
            this.showLoader = false;
          } else this.showLoader = false;
        },
        (err) => {
          this.showLoader = false;
          console.log(err);
        }
      );
    },
    getDocSmartUtilityIncome(dashboardData) {
      let newUtilitiesFees = 0;
      newUtilitiesFees =
        dashboardData.total_utility_fees -
        dashboardData.total_utility_fees / 6.55 +
        dashboardData.razor_pay_fee * 0.18 -
        dashboardData.razor_pay_fee;
      return newUtilitiesFees.toFixed(2);
    },
    getPaymentGateway(dashboardData) {
      let newPaymentGateway = 0;
      newPaymentGateway =
        (dashboardData.total_utility_fees - dashboardData.razor_pay_fee) / 6.55;
      return newPaymentGateway.toFixed(2);
    },
  },
};
</script>
